import { jsx as _jsx } from "react/jsx-runtime";
import { IconSize, InfoCircleIcon } from '@prophecy/icons';
import { Tooltip } from '../Tooltip';
export function Hint({ placement = 'top', color, size = IconSize.s, iconProps, className, ...restProps }) {
    return (_jsx(Tooltip, { placement: placement, ...restProps, children: _jsx("span", { children: _jsx(InfoCircleIcon, { type: 'default', size: size, color: color, className: className, ...iconProps }) }) }));
}
